import Vue from 'vue';

const $checkEmail = ( address, required = false ) => {
  if ((!address || !address.length) && required) return false;
  let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(address);
};

Vue.prototype.$checkEmail = $checkEmail;

export default $checkEmail;
